// extracted by mini-css-extract-plugin
export default {"toastContainer":"styles_toastContainer__ghO5s","topPriority":"styles_topPriority__4Nlre","bone-skeleton":"styles_bone-skeleton__NPR-G"};